import { useEffect } from "react";
export var useDisableRadixScrollLock = function (isOpen) {
    useEffect(function () {
        if (!isOpen) {
            return;
        }
        var removeScrollLock = function () {
            var lockedElement = document.querySelector("[data-scroll-locked='1']");
            if (lockedElement) {
                lockedElement.removeAttribute("data-scroll-locked");
            }
        };
        removeScrollLock();
        var rafOne = requestAnimationFrame(removeScrollLock);
        var rafTwo = requestAnimationFrame(removeScrollLock);
        var observer = new MutationObserver(function () {
            removeScrollLock();
        });
        observer.observe(document.documentElement, {
            attributes: true,
            subtree: true,
            attributeFilter: ["data-scroll-locked"],
        });
        return function () {
            cancelAnimationFrame(rafOne);
            cancelAnimationFrame(rafTwo);
            observer.disconnect();
        };
    }, [isOpen]);
};
